module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Moviles-1-zoom.a8d657fd.png";